<template>
  <div>
    <v-breadcrumbs
      :items="breadcrumbs"
      class="grey lighten-2 white--text"
    ></v-breadcrumbs>
    <div class="pa-4 grey lighten-4">
      <div class="d-flex align-center justify-space-between mb-4">
        <p class="subtitle-1 ma-0">
          Escolha uma linha de produto abaixo para editar ou excluir.
        </p>
        <v-btn
          v-if="linhaCriar"
          small
          depressed
          color="fmq_gray"
          dark
          to="/criar-linha-produtos"
          >Nova Linha de Produto</v-btn
        >
      </div>
      <LinhasTabelas
        :headers="headers"
        :linhas="linhas"
        :loading="loading"
        :total="totalLinhas"
        :pageText="pageText"
        :pageNumber="page"
        @handleFilter="filter"
        @excluir="excluirModal"
      >
        <template v-slot:nome>
          <v-text-field
            v-model="formData.nome"
            placeholder="Digite o nome"
            solo
            flat
            dense
            :hide-details="true"
            @input="
              page = 1;
              getLinhas(formData, page);
            "
            :clearable="true"
            :full-width="true"
          >
          </v-text-field>
        </template>

        <template v-slot:id>
          <div class="d-flex justify-start">
            <v-btn class="mr-2" outlined x-small fab color="red" @click="clear">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-btn outlined x-small fab color="blue" @click="search">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </div>
        </template>
      </LinhasTabelas>
    </div>
    <AlertConfirmation
      :dialog="dialog"
      :dialogMessage="dialogMessage"
      @close="dialog = false"
      @accept="excluir"
    />
    <AlertSuccess
      :dialog="success"
      dialogMessage="Linha de Produto excluida com sucesso"
      @close="
        getLinhas(formData, page);
        success = false;
      "
    />
    <AlertError :alertError="error" :messageError="messageError" />
  </div>
</template>

<script>
import LinhasTabelas from "@/components/linhas/LinhasTabelas.vue";
import { buscarLinha, excluirLinha } from "@/services/linhas";
export default {
  name: "LinhasDeProdutos",
  components: { LinhasTabelas },
  data: () => ({
    breadcrumbs: [
      {
        text: "Linha de Produtos",
        disabled: true,
        to: "Linha de Produtos",
      },
    ],
    headers: [
      { text: "Nome da Linha de Produtos", value: "nome", width: "90%" },
      { text: "Ações", value: "id", sortable: false },
    ],
    loading: false,
    linhas: [],
    totalLinhas: null,
    pageText: null,
    page: 1,
    formData: {
      orderBy: null,
      orderSorted: null,
      perPage: 15,
      nome: null,
    },
    dialog: false,
    dialogMessage: null,
    linhaId: null,
    error: false,
    success: false,
    messageError: null,
  }),
    beforeCreate() {
    if(this.$store.state.user.data.tipo === "Representante") {
      this.$router.push({path: '/'})
    }
  },
  created() {
    if (this.$store.state.linhasSearch.length) {
      this.formData = { ...this.$store.state.linhasSearch[0] };
    }
    this.getLinhas(this.formData, this.page);
  },
  methods: {
    async getLinhas(payload, page) {
      this.produtos = [];
      this.$store.dispatch("setLinhasProdutosSearch", payload);
      try {
        this.loading = true;
        const resp = await buscarLinha(payload, page);
        this.linhas = resp.data.data;
        this.totalLinhas = resp.data.total;
        this.pageText = `${resp.data.from}-${resp.data.to} de ${resp.data.total}`;
      } catch (e) {
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    clear() {
      this.$store.dispatch("setLinhasProdutosSearch", {});
      this.formData.nome = null;
      this.page = 1;
      this.getLinhas(this.formData, this.page);
    },
    search() {
      this.page = 1;
      this.getLinhas(this.formData, this.page);
    },
    filter(event) {
      this.$store.dispatch("setLinhasProdutosSearch", this.formData);
      this.formData.orderSorted = event.orderSorted;
      this.formData.perPage = event.perPage;
      this.page = event.page;
      this.getLinhas(this.formData, this.page);
    },
    async excluir() {
      this.error = false;
      this.sucess = false;
      try {
        await excluirLinha(this.linhaId).then(() => {
          this.dialog = false;
          this.success = true;
        });
      } catch (e) {
        this.dialog = false;
        this.error = true;
        this.messageError = e.response.data.message;
      }
    },
    excluirModal(item) {
      this.dialogMessage = `Tem certeza que deseja excluir ${item.nome}?`;
      this.dialog = true;
      this.linhaId = item.id;
    },
  },
  computed: {
    linhaCriar() {
      return this.$store.state.user.data.permissoes.includes(
        "linha.criar"
      );
    },
  },
};
</script>

<style></style>
